import React, { useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles, IconButton } from '@material-ui/core'
import { Send } from 'mdi-material-ui'
import { toggleDialog } from 'actions/view'
import { sendMessageToOpenAi } from 'components/VastGPT/redux'
import { list } from 'actions/data'
// import { DATA_API_URL } from 'utils/AllURLs'

const AiInput = ({
  classes,
  toggleDialog,
  sendMessageToOpenAi,
  list,
}) => {
  const [input, setInput] = useState('')

  const aiFunction = async () => {
    // list('openaichat', null, `${DATA_API_URL}/openaichat`)

    toggleDialog({
      open: true,
      dialog: 'AiKnowledge',
      options: { input },
    })

    await sendMessageToOpenAi({
      content: input,
      firstMessage: true,
    })

    setInput('')
  }

  return (
    <>
      <div className={classes.textField}>
        <input
          onKeyPress={e => {
            if (e.charCode === 13) {
              aiFunction()
            }
          }}
          value={input}
          onChange={e => setInput(e?.target?.value)}
          className={classes.input}
          placeholder="Enter a question or command"
        />
      </div>
      <IconButton
        // variant="contained"
        // color="secondary"
        disabled={!input}
        style={{
          backgroundColor: !input ? 'gray' : '#014c94',
          color: '#fff',
          marginLeft: 5,
        }}
        onClick={() => {
          aiFunction()
        }}
      >
        <Send />
      </IconButton>
    </>
  )
}

export default connect(
  null,
  dispatch =>
    bindActionCreators(
      { toggleDialog, sendMessageToOpenAi, list },
      dispatch,
    ),
)(
  withStyles(theme => ({
    textField: {
      backgroundColor: '#fff',
      width: 'calc(100% - 53px)',
      borderRadius: 35,
      padding: 9,
      height: 48,
      borderWidth: 1,
      border: 'solid #707070',
      display: 'inline-block',
    },
    input: {
      fontSize: 20,
      borderWidth: 0,
      width: '100%',
      '&:focus': {
        outline: 'none',
      },
    },
  }))(AiInput),
)
